export default __webpack_public_path__ + "static/stainless-steelHero-6637c4adbb48a1f24b1d58a0342ebf4c.jpg";